import { useState } from "react";
import Layout from "../shared/Layout";
import PageHeader from "../shared/PageHeader";
import FilterBar from "../../components/settings/FilterBar";
import SettingsToolbar from "../../components/settings/SettingsToolbar";
import language from "../../variables/language";
import useCronLogFeed from "./useCronLogFeed";
import BackgroundHealthRow from "./BackgroundHealthRow";
import usePersistedState from "../../hooks/usePersistedState";
import "../../css/background-health.css";

export default function BackgroundHealth() {
    const t = language[language.lang].backgroundHealthPage;

    const [type, setType] = useState("");
    const [level, setLevel] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [viewMode, setViewMode] = usePersistedState("background-health-view-mode", "recent");

    const { rows, status } = useCronLogFeed({ type, level, dateFrom, dateTo, viewMode });

    const TYPE_OPTIONS = [
        { id: "", name: t.allTypes },
        { id: "WORD_CLASSIFICATION", name: t.typeWordClassification },
        { id: "WORD_DISCOVERY", name: t.typeWordDiscovery },
        { id: "LESSON_REMINDER", name: t.typeLessonReminder },
        { id: "CALENDAR_SYNC", name: t.typeCalendarSync },
        { id: "PLANNED_EVENTS", name: t.typePlannedEvents },
        { id: "CYCLED_LESSON_PROPAGATION", name: t.typeCycledLessonPropagation },
        { id: "TELEGRAM_SEND", name: t.typeTelegramSend },
    ];

    const LEVEL_OPTIONS = [
        { id: "", name: t.allLevels },
        { id: "INFO", name: t.levelInfo },
        { id: "WARNING", name: t.levelWarning },
        { id: "ERROR", name: t.levelError },
    ];

    return (
        <Layout>
            <SettingsToolbar />
            <PageHeader name={t.title}>
                <div className="bg-health-toggle">
                    <span className={viewMode === "recent" ? "active" : ""} onClick={() => setViewMode("recent")}>
                        {t.viewRecent}
                    </span>
                    <span className={viewMode === "aggregated" ? "active" : ""} onClick={() => setViewMode("aggregated")}>
                        {t.viewAggregated}
                    </span>
                </div>
                <FilterBar
                    filters={[
                        { key: "type", label: t.filterType, value: type, onChange: setType, options: TYPE_OPTIONS },
                        { key: "level", label: t.filterLevel, value: level, onChange: setLevel, options: LEVEL_OPTIONS },
                        { key: "dateFrom", type: "date", label: t.filterFrom, value: dateFrom, onChange: setDateFrom },
                        { key: "dateTo", type: "date", label: t.filterTo, value: dateTo, onChange: setDateTo },
                    ]}
                    resultCount={status === "done" ? rows.length : null}
                />
            </PageHeader>
            <main className="main-block">
                <div className="main-content txt-c">
                    {status === "loading" ? <p className="bg-health-empty">{t.loading}</p> : ""}
                    {status === "error" ? <p className="bg-health-empty">{t.loadError}</p> : ""}
                    {status === "done" && rows.length === 0 ? <p className="bg-health-empty">{t.noEntries}</p> : ""}
                    {status === "done" && rows.length > 0 ? (
                        <ul className="bg-health-list">
                            {rows.map((row) => (
                                <BackgroundHealthRow key={row.id} row={row} viewMode={viewMode} t={t} />
                            ))}
                        </ul>
                    ) : (
                        ""
                    )}
                </div>
            </main>
        </Layout>
    );
}
